<template>
<div id="" class="oo content spacing-top spacing-bottom">
  <div class="oo text spacing-top-xl spacing-bottom">
    <h1 string="split" string-split="char" class="oo title">{{ page.h1 }}</h1>
    <div v-html="page.body"></div>
  </div>
</div>
</template>
<script setup lang="ts">
definePageMeta({
  scrollToTop: false
});

const { locale } = useI18n()
const { data: page } = await useAsyncData(`content-aviso-legal-${locale.value}`, async () => {
  const result = await queryCollection('docs').path(`/${locale.value}/aviso-legal`).first();
  return result?.meta ?? {};
});
</script>
